import React, { useState } from 'react';
import './styles.scss';
function CloseIcon() {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        React.createElement("path", { d: "M12 4L4 12M4 4L12 12", stroke: "#1e4b7a", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
}
export function MainContentBanner({ title, buttonTitle, dismissTitle, dismissKey, onClick, icon }) {
    const [isVisible, setIsVisible] = useState(() => {
        return localStorage.getItem(dismissKey) !== 'true';
    });
    const handleClose = (e) => {
        e.stopPropagation();
        localStorage.setItem(dismissKey, 'true');
        setIsVisible(false);
    };
    if (!isVisible) {
        return null;
    }
    return (React.createElement("div", { className: "main-content-banner" },
        React.createElement("div", { className: "main-content-banner__content" },
            icon,
            React.createElement("strong", null, title)),
        React.createElement("button", { className: "main-content-banner__review-button", onClick: onClick, type: "button", "aria-label": buttonTitle, title: buttonTitle }, buttonTitle),
        React.createElement("button", { className: "main-content-banner__close", onClick: handleClose, type: "button", "aria-label": dismissTitle, title: dismissTitle },
            React.createElement(CloseIcon, null))));
}
